import { getCareerBenefits, t } from '../i18n.js';
import { renderPageCta, renderPageHero } from './shared.js';
import { $, escapeHtml } from '../utils/index.js';

const benefitIcon =
  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4.5l1.55 3.95L17.5 10l-3.95 1.55L12 15.5l-1.55-3.95L6.5 10l3.95-1.55L12 4.5z" fill="currentColor"/><path d="M18.3 4.8l.7 1.78 1.78.7-1.78.7-.7 1.78-.7-1.78-1.78-.7 1.78-.7.7-1.78zM6 15.8l.92 2.28 2.28.92-2.28.92L6 22.28 5.08 20 2.8 19.08 5.08 18.16 6 15.8z" fill="currentColor" opacity=".74"/></svg>';

export function renderCareer(): void {
  const el = $('#page-career');
  if (!el) return;

  const benefits = getCareerBenefits();

  el.innerHTML = `
    ${renderPageHero({
      label: t('career.label'),
      title: t('career.title'),
      intro: t('career.intro'),
      kicker: 'Work culture',
      stack: ['Deep work', 'Respectful pace', 'Modern stacks', 'Meaningful products'],
    })}
    <section class="section">
      <div class="container section-head animate-on-scroll">
        <p class="section-kicker">${t('career.perks.title')}</p>
        <h2 class="section-title">${t('career.perks.intro')}</h2>
      </div>
      <div class="container benefits-grid">
        ${benefits
          .map(
            (benefit, index) => `
              <article class="benefit-card animate-on-scroll" style="animation-delay: ${(index % 4) * 0.05}s">
                <span class="benefit-icon">${benefitIcon}</span>
                <div>
                  <h3>${escapeHtml(benefit.title)}</h3>
                  <p>${escapeHtml(benefit.description)}</p>
                </div>
              </article>
            `
          )
          .join('')}
      </div>
    </section>
    ${renderPageCta({
      label: t('career.open.title'),
      title: 'We hire carefully and stay open to exceptional people.',
      body: t('career.open.body'),
      buttonLabel: t('career.open.cta'),
      sectionClassName: 'section section-premium',
      sectionAttrs: 'data-route-anchor="open-positions" id="career-open-positions"',
    })}
  `;
}
